<template>
  <div class="btn compact theme-button">
    <span class="hole">
      <span>A</span>
    </span>
  </div>
</template>

<style lang='scss'>
.theme-button {
  position: relative;
  background-color: red;
  background: conic-gradient(
    lch(70% 70 20) 0%,
    lch(88 114.4 87.05) 25%,
    lch(77 48.02 233.9) 50%,
    lch(58 70.2 292.06) 75%,
    lch(70% 70 360) 100%
  );
  color: var(--color-text);
  font-family: var(--font-family-main);
  // font-size: var(--font-size-lg);
  .hole {
    display: grid;
    place-content: center;
    width: var(--padding-big);
    height: var(--padding-big);
    background-color: var(--color-bg);
    border-radius: 50%;
  }
}
</style>
